module.exports = __webpack_public_path__ + "img/p2.8b01334e.png";